export const AlignTopIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16" width="16" fill="none">
    <path
      d="M1.3335 1.33464V2.66797H14.6668V1.33464H1.3335ZM4.66683 4.0013V14.668H6.66683V4.0013H4.66683ZM9.3335 4.0013V10.668H11.3335V4.0013H9.3335Z"
      fill="currentColor"
    />
  </svg>
);
